import React from 'react';
import VisitCardSkeletonLoader from './VisitCardSkeletonLoader';

export default {
  title: 'Components/LoadingSkeletons/VisitCardSkeletonLoader',
  component: VisitCardSkeletonLoader,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    shouldEnableAnimation: {
      control: { type: 'boolean' },
      description: 'Controls the shouldEnableAnimation prop. By default, it is set to false to keep animations disabled. Set this value to true to enable animations.',
      table: {
        type: { summary: 'Boolean' },
        defaultValue: { summary: false },
      },
    },
    UsageHint: {
      description: 'Usage example: `[...Array(9)].map((_, index) => <VisitCardSkeletonLoader key={index} />)`',
    },
    skeletonHeight: {
      control: { type: 'number' },
      description: 'Specifies the height of the skeletons for each line of text.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 16 },
      },
    },
    skeletonStatusWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the status text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '30%' },
      },
    },
    skeletonSiteNameWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the site name text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '70%' },
      },
    },
    skeletonDateWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholder for the date text.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '50%' },
      },
    },
    skeletonLabelWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholders for labels in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '30%' },
      },
    },
    skeletonValueWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the skeleton placeholders for values in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '50%' },
      },
    },
  },
};

const Template = (args) => (
  <div className="w-109">
    <VisitCardSkeletonLoader {...args} />
  </div>
);

export const Default = Template.bind({});
Default.args = {
  skeletonHeight: 16,
  skeletonStatusWidth: '30%',
  skeletonSiteNameWidth: '70%',
  skeletonDateWidth: '50%',
  skeletonLabelWidth: '30%',
  skeletonValueWidth: '50%',
};

export const SmallSkeletonLoader = Template.bind({});
SmallSkeletonLoader.args = {
  skeletonHeight: 12,
  skeletonStatusWidth: '25%',
  skeletonSiteNameWidth: '60%',
  skeletonDateWidth: '40%',
  skeletonLabelWidth: '20%',
  skeletonValueWidth: '40%',
};

export const LargeSkeletonLoader = Template.bind({});
LargeSkeletonLoader.args = {
  skeletonHeight: 24,
  skeletonStatusWidth: '40%',
  skeletonSiteNameWidth: '80%',
  skeletonDateWidth: '60%',
  skeletonLabelWidth: '35%',
  skeletonValueWidth: '60%',
};
